// Standard Library
// 3rd Party
// Local
import { UriAwareMixin } from './mixins/uri-aware.js';

/** Uri Router Navigation element. */
// eslint-disable-next-line new-cap
class UriResponsiveElement extends UriAwareMixin(HTMLElement) {
  /**
   * Gets the list of attributes to observe for changes
   * @returns {string[]} Array of attribute names to observe
   */
  static get observedAttributes() {
    return ['uri', 'fragment'];
  }

  /**
   * Creates a new URI responsive element
   */
  constructor() {
    super();
  }

  /**
   * Handles attribute changes
   * @param {string} name - The name of the changed attribute
   * @param {string} oldValue - The previous value of the attribute
   * @param {string} newValue - The new value of the attribute
   */
  attributeChangedCallback(name, oldValue, newValue) {
    const hasValue = newValue !== null;

    if (name === 'uri' && hasValue) {
      if (this.hashMap[this.fragment] !== newValue) {
        this.hashValue = newValue;
      }

      if (oldValue !== newValue) {
        // Responding to the URI change.
        this.onUriChange(this.hashValue);
      }
    }
  }

  /**
   * Called when the element is connected to the DOM
   */
  connectedCallback() {
    window.addEventListener('hashchange', this.onHashChange.bind(this), false);
    window.dispatchEvent(new Event('hashchange'));
  }

  /**
   * Called when the element is disconnected from the DOM
   */
  disconnectedCallback() {
    window.removeEventListener('hashchange', this.onHashChange.bind(this), false);
  }

  /**
   * Handles hash change events
   */
  onHashChange() {
    if (this.hashValue !== undefined) {
      this.setAttribute('uri', this.hashValue);
    }
  }

  /**
   * Handles URI changes - to be overridden by users
   * @param {string} hashValue - The new hash value
   */
  onUriChange(hashValue) {}
}

export { UriResponsiveElement };
